import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckCircleIcon } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabel, trackCheckout } from '../data/offer';
const highlights = ['6 Complete Volumes', '5 Premium Bonuses', 'Instant Access'];
export function Hero() {
  return <section className="relative bg-ivory text-charcoal px-4 pt-8 pb-14 sm:pt-12 sm:pb-20 border-b border-sand-deep" data-id="element-163" data-mp="4n9z0lnv3m4r">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-164" data-mp="127eeddqu7pdg">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-165" data-mp="xaxexne6tol2">
          <p className="inline-block px-3 py-1 rounded-full border border-orange/50 bg-orange-soft text-orange-deep font-semibold text-[11px] sm:text-sm tracking-wide mb-5" data-id="element-166" data-mp="nbyir4alzley">
            HYBRID RACE COACH READY
          </p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-bold uppercase leading-tight mb-4" data-id="element-167" data-mp="3j8ixl0k6uiv8">
            Resolve 120 complete hybrid racing sessions{' '}
            <span className="text-orange" data-id="element-168" data-mp="3o5j1b4tkf9j6">in just 5 minutes</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full max-w-[320px] sm:max-w-lg md:max-w-2xl mb-6" data-id="element-169" data-mp="39cpcgsselh1u">
          <img src="https://cdn.magicpatterns.com/uploads/2GWkwfZzEQ5nDsprskAgE9/Diseno_sin_titulo_(62).png" alt="Hybrid Race Coach Ready — 120 ready-to-train sessions across 6 complete volumes plus 5 premium bonus guides" className="w-full h-auto drop-shadow-2xl" data-id="element-170" data-mp="35aax4iny0zfb" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-171" data-mp="2lkqyg11kl7l0">
          <p className="text-base sm:text-lg md:text-xl text-warmgray leading-snug max-w-3xl mx-auto mb-7" data-id="element-172" data-mp="nat6xa8uyik6">
            <span className="font-semibold text-charcoal" data-id="element-173" data-mp="ibgod1p0rxne">
              Hybrid Race Coach Ready
            </span>{' '}
            — 120 ready-to-coach sessions inside a complete 6-volume coaching
            system
          </p>
          <div className="flex justify-center mb-7" data-id="element-174" data-mp="1b0duy7jvc60b">
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-4 sm:py-5 px-6 sm:px-10" data-id="element-175" data-mp="161ayvclv9a4h">
              {ctaLabel}
              <ArrowRightIcon size={20} aria-hidden="true" data-id="element-176" data-mp="x0uxc8oood29" />
            </Button>
          </div>
          <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-warmgray" data-id="element-177" data-mp="3lui6mj3rolho">
            {highlights.map(highlight => <li key={highlight} className="flex items-center gap-1.5" data-id="element-178" data-mp="1x9ul8c2qhfny">
                <CheckCircleIcon size={14} className="text-orange shrink-0" aria-hidden="true" data-id="element-179" data-mp="1x7hxtje7id3i" />
                <span data-id="element-180" data-mp="268g468c4awp9">{highlight}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}